import React, { PureComponent } from "react";
import "./FinalPage.css";
import DiscountBadge from "./DiscountBadge";
import proctection_LIST from "./_ProtectionList.json";
import APIUtilities from './APIUtilities.js'
import { normaliserParametres, calculerRemisesParItem, calculerPrixNet } from './calculRemises';
import { Button, Modal } from 'antd';

export default class FinalPage extends PureComponent {

  componentDidMount() {

    const { campaign } = this.props;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("campagne", campaign);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, null, newUrl);

  }

  addRecapItems() {

    return(
      <div className="component-recap-bloc">
        <div className="component-recap-bloc-image">
            {this.printImg()}
        </div>
        <div className="component-recap-bloc-model">
          <div className="component-recap-bloc-model-title">
            {this.printModel()}
          </div>
          <div>
            {this.printSelectedItems()}
          </div>
        </div>
      </div>
    );
  }

  //div protection
  printItemProtection(item) {
    return(
      <label className="lab">
      <div className="item-protection-recapPage">
      <div>
        <img src={item.PictoPath_Piece} className="picto-protection-recapPage"/>
      </div>
      <div className="box-protection">
        <div className="info-box-label-proctection-recapPage">
          {item.Piece}
        </div>
      </div>
      </div>
      </label>);
  }

  printImg() {
    const idPhone = parseInt(this.props.model.IDModele);
    if(idPhone === -1 || idPhone == undefined) {
      if(this.props.category != undefined)
      return <img alt ={this.props.category.LibelleCategorie} src={this.props.category.URL_IMG} />;
    }
      

    return <img alt ={this.props.model.LibelleModele} src={this.props.model.URL_IMG} />;
  }

  printModel() {
    const idCat = parseInt(this.props.category.IDCategorie);
    const idBrand = parseInt(this.props.brand.id);
    const idPhone = parseInt(this.props.model.IDModele);

    //Catégories autres que "Téléphone" ou (catgéorie "Téléphone" et marque "Autre")
    if(idCat !== 2 || idBrand === 0)
      return(this.props.category.LibelleCategorie);

    //Catégorie "Téléphone" et modèle "autre"
    if(idPhone < 1)
      return(this.props.category.LibelleCategorie + " " + this.props.brand.name);

    return(this.props.model.LibelleMarque + " "+this.props.model.LibelleModele);
  }

  printSelectedItems() {
    const items = this.props.selectedItems;

    // Exclure l'élément avec l'ID 2493
    const filteredItems = items.filter(item => item.IDArticle !== 2493);

    if (filteredItems.length === 0)
      return (<div style={{fontWeight: '100' }}>Aucune réparation sélectionnée</div>);

    // Remise ligne à ligne (TICK00299) : le prix remisé est affiché en face de
    // chaque réparation, avec le taux qui lui a été appliqué. Recalculé depuis
    // selectedItems avec le même moteur que PhoneData et que le serveur.
    const remises = calculerRemisesParItem(filteredItems, this.props.offreBatterie);

    const labels = filteredItems.map((item, index) => {
      const remise = remises[item.IDArticle];
      const prix   = Number(item.PrixTTC) || 0;
      const net    = calculerPrixNet(prix, remise != null ? remise.pourcentage : 0);

      return (
        <div key={index} className="recap-ligne">
          <span className="recap-ligne-libelle">{item.Piece}</span>
          <span className="recap-ligne-prix">
            {remise != null &&
            <span className="recap-prix-barre">{prix.toFixed(2)}€</span>}
            <span className="recap-prix-net">{net.toFixed(2)}€</span>
            {remise != null &&
            <DiscountBadge label={"-" + remise.pourcentage + "%"} variant="bleu"/>}
          </span>
        </div>
      );
    });

    return (
      <div>
        Réparation :
        <div style={{fontWeight: '100' }}>{labels}</div>
      </div>
    );
  }

  //affichage de la div protection si selectionner
  printProtection(item) {
      const items = this.props.selectedItems;

      if (items.find(item => item.IDArticle === 2493)) {
        return (
          <div className="component-phone-data-item-list">

            {proctection_LIST.map(item => (
              <div key={item.IDArticle} className="component-phone-data-item-element">
                {this.printItemProtection(item)}
              </div>
            ))}

          </div>
        );
      }
      return null;
  }

  // Les remises (-10% / -20% / -50%) sont désormais posées sur chaque
  // réparation (TICK00299) : props.total est déjà le prix net à payer, il ne
  // faut plus lui appliquer de remise web globale. Seul le bonus QualiRépar
  // reste affiché sans être enregistré (accordé en boutique si éligible).
  getBonusQualiRepar() {
    return normaliserParametres(this.props.offreBatterie).bonusQualiRepar;
  }

  // Montant avant remise : props.total est net de props.discount.
  printMontantAvantRemise() {
    if(this.props.total === 0)
      return "Sur devis";
    return (this.props.total + (this.props.discount || 0)).toFixed(2)+"€";
  }

  printTotal() {
    if(this.props.total === 0)
      return "Sur devis";
    return this.props.total.toFixed(2)+"€";
  }

  printTotalBonusReparation() {
    if(this.props.total === 0){
      return "Sur devis";
    }
    return Math.max(0, this.props.total - this.getBonusQualiRepar()).toFixed(2)+"€";
  }

  // Somme totale économisée, affichée sous le total : remises déjà déduites du
  // montant (remises par réparation + code promo via props.discount) + bonus
  // réparation (inclus dans le total affiché).
  printEconomie() {
    if (this.props.total === 0)
      return null;

    const economie = (this.props.discount || 0) + this.getBonusQualiRepar();

    if (economie <= 0)
      return null;

    return (
      <div className="prix-economie">
        Grâce aux remises, vous économisez <b>{economie.toFixed(2)}€</b> !
      </div>
    );
  }

  state = {
    showModal: false,
  };

  toggleModal = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal,
    }));
  };

  showModal = () => {

    this.props.onClickFunction();

     // Affichage de la page de rendez-vous.

      /*
        APIUtilities.sendDemandeRDVDevis(this.props.GUID);
        this.setState({
          showModal: true,
        });

    */

};

hideModal = () => {
  this.setState({
    showModal: false,
  });
};

handleOk = () => {
  this.hideModal();
};

  render() {
    return (
      <>
      <div className="end-message">
        <h4>Récapitulatif de ma demande</h4>
        <div className="component-recap-FinalPage">
          {this.addRecapItems()}
        </div>
        {this.printProtection()}

        {/* Offre batterie (TICK00276) : remise déjà déduite du montant ci-dessous.
            Bloc autonome, hors des blocs à marges négatives existants. */}
        {this.props.discountBatterie > 0 &&
        <div className="final-offre-batterie">
          <DiscountBadge label={"-" + (this.props.offreBatterie != null && Number(this.props.offreBatterie.pourcentage) > 0 ? Number(this.props.offreBatterie.pourcentage) : 50) + "%"} variant="bleu"/>
          {" Offre batterie : -" + this.props.discountBatterie.toFixed(2) + "€ sur le remplacement de votre batterie (déjà déduite)"}
        </div>}

        {/* Carte « Détail du tarif » : lignes libellé | montant (remplace les
            blocs à marges négatives -35/-57/-89px, fragiles au changement de
            police et purgés d'App.css au lot D). */}
        <div className="prix-carte">
          <div className="prix-ligne">
            <span className="prix-libelle">Montant avant remise (TTC)</span>
            <span className="prix-montant">{this.printMontantAvantRemise()}</span>
          </div>
          {/* Remises par réparation (-10% / -20% / -50%) et code promo : déjà
              déduits du montant ci-dessous (props.total est net). */}
          {this.props.discount != 0 &&
          <div className="prix-ligne">
            <span className="prix-libelle"><DiscountBadge label={"-" + this.props.discount.toFixed(2) + "€"} variant="bleu"/> Remises appliquées</span>
            <span className="prix-montant prix-montant-deduit">déjà déduites ✓</span>
          </div>}
          <div className="prix-ligne">
            <span className="prix-libelle">Prix après remises (TTC)</span>
            <span className="prix-montant">{this.printTotal()}</span>
          </div>
          <div className="prix-ligne">
            <span className="prix-libelle"><DiscountBadge label={"-" + this.getBonusQualiRepar() + "€"} variant="vert"/> si éligible au bonus réparation(1)</span>
            <span className="prix-montant">{this.printTotalBonusReparation()}</span>
          </div>
          <div className="prix-total">
            <span className="prix-total-libelle">Total (TTC)</span>
            <span className="prix-total-montant">{this.printTotalBonusReparation()}</span>
          </div>
        </div>

        {this.printEconomie()}


     

















        <div className="end-message_rdv">
          { 
            <button type="button" onClick={this.showModal}>{this.props.IsStockPieceDispo == true ? "Prendre rendez-vous en ligne" : "Prendre rendez-vous en ligne"}</button>
          }
        
        </div>

        <div className="sub-info">
        Le récapitulatif de votre demande a été envoyé sur l’email indiqué précédemment, pensez à vérifier vos spams !
        </div>
        </div>
      <div className="box-info">
     
      <div className=" end-message end-message-button">
       

      <Modal
        title={<h2 className="modal-title">Merci !</h2>}
        visible={this.state.showModal}
        onCancel={this.hideModal}
        footer={[
          <Button key="fermer" onClick={this.handleOk}>
            Fermer
          </Button>,
        ]}
      >
        <p className="modal-text">
          Votre prise de rendez-vous a bien été prise en compte, notre équipe reviendra vers vous au plus vite.
        </p>
      </Modal>

      </div>
      {/* Lot D : l'ancien <a> englobait aussi le bouton « nouveau devis » et le
          texte d'information (liens imbriqués invalides) — chaque bloc a
          maintenant son propre lien. */}
      <a href="https://www.phoner.co/acheter-son-smartphone-neuf-reconditionne">
      <div className="end-info">
      Découvrir nos smartphones reconditionnés &#x1F1EB;&#x1F1F7;
      </div>
      </a>
      <div className=" end-message end-message-button">
          <a href="/"><button>Générer un nouveau devis</button></a>
      </div>
      <div className="sub-info">
      Un de nos techniciens va prendre contact avec vous <strong>par téléphone et par mail</strong> pour définir une date de rendez-vous en boutique sous 24h
      </div>

      <div className="detailBonusReprise">
        (1) Le bonus réparation Qualirepar n’est valable que sur le territoire Français sous condition d’acceptation par les éco-organisme selon l’éligibilité du produit et de la panne. L’éligibilité est testée et vous sera confirmée en point de vente par nos techniciens au moment du rendez-vous réparation. Voir conditions sur label-qualirepar.fr
      </div>

      </div>
      </>);
  }
}
